import { CardRecAlternateNames } from '@/components/common/Card'
import { usePage } from '@/components/providers/PageProvider'

import styles from './FeaturedRecTitle.module.scss'

type Props = {
  subtitle?: string
  title: string
}

export const FeaturedRecTitle = ({ subtitle, title }: Props) => {
  const { page } = usePage()
  const rec = page?.featured?.rec

  if (!rec) return null

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        <span className={styles.headingMain}>{title}</span>
        {subtitle && <span className={styles.headingSubtitle}>{subtitle}</span>}
      </h1>
      <CardRecAlternateNames rec={rec} />
    </div>
  )
}
